import {ChangeDetectionStrategy, Component, inject, Input, OnDestroy, OnInit} from '@angular/core';
import {CatalogRecord, Environment} from '@raven';
import {isPopulatedString} from '@store/common/typing.helpers';

@Component({
  selector: 'rn-catalog-details-novelist-tab',
  templateUrl: './catalog-details-novelist-tab.component.html',
  styleUrl: './catalog-details-novelist-tab.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CatalogDetailsNovelistTabComponent implements OnInit, OnDestroy {
  @Input() catalogRecord: CatalogRecord;
  @Input() novelistProfile: string;
  @Input() novelistPassword: string;
  private readonly environment = inject(Environment);
  private novelistScript: HTMLElement;
  private readonly loadNovelistScriptListener = () => this.queryNovelist();
  public noData = false;

  ngOnInit(): void {
    if (isPopulatedString(this.catalogRecord?.identifier) &&
      isPopulatedString(this.novelistProfile) &&
      isPopulatedString(this.novelistPassword)) {
      this.loadNovelistScript();
    } else {
      this.noData = true;
    }
  }

  ngOnDestroy() {
    this.novelistScript?.removeEventListener('load', this.loadNovelistScriptListener);
  }

  private loadNovelistScript(): void {
    const id = 'novelistScript';
    const body: HTMLElement = document.body;
    this.novelistScript = document.getElementById(id);
    if (this.novelistScript === null) {
      this.novelistScript = document.createElement('script');
      this.novelistScript.setAttribute('id', id);
      this.novelistScript.setAttribute('src', this.environment.novelistApiUrl);
      body.appendChild(this.novelistScript);
      this.novelistScript.addEventListener('load', this.loadNovelistScriptListener);
    } else {
      this.queryNovelist();
    }
  }

  private queryNovelist() {
    const novSelect = window['novSelect'];
    if (!novSelect) {
      throw new Error('Novelist Select failed to load properly');
    }
    novSelect.loadContentForQuery({
        ClientIdentifier: this.catalogRecord.identifier,
        ISBN: this.catalogRecord.identifier,
        version: '2.3'
      },
      this.novelistProfile,
      this.novelistPassword
    );
  }
}
